import { decodeExpiry } from '@/libs/utils'
import jwtDecode from 'jwt-decode'
import Vue from 'vue'
import VueCryptojs from 'vue-cryptojs'

/** @type {VueWithCryptoJS} */
const vue = Vue

vue.use(VueCryptojs)

const decryptData = data => vue.CryptoJS.AES.decrypt(data, process.env.VUE_APP_COOKIE_SECRET).toString(vue.CryptoJS.enc.Utf8)
const encryptData = data => vue.CryptoJS.AES.encrypt(data, process.env.VUE_APP_COOKIE_SECRET).toString()

const storeToLocalStorage = (name, data) => {
  localStorage[name] = encryptData(data)
}

const getFromLocalStorage = name => {
  const item = localStorage[name]
  if (!item) return null
  return decryptData(item)
}
const pages = getFromLocalStorage('pages')
const state = {
  token: getFromLocalStorage('token'),
  // exp: null,
  user: getFromLocalStorage('userName'),
  accessLevel: Number(getFromLocalStorage('accessLevel')) || 0,
  mainPage: getFromLocalStorage('mainPage') || '',
  pages: pages ? JSON.parse(pages) : [],
}
const mutations = {
  SET_TOKEN(state, payload) {
    state.token = payload
    state.exp = decodeExpiry(payload)
  },
  SET_MAIN_PAGE(state, payload) {
    state.mainPage = payload
  },
  SET_USER(state, payload) {
    state.user = payload
  },
  SET_ACCESS_LEVEL(state, payload) {
    state.accessLevel = payload
  },
  SET_PAGES(state, payload) {
    state.pages = payload
  },
  CLEAR_TOKEN(state) {
    state.token = null
    state.exp = null
    state.accessLevel = null
    state.user = null
  },
}

const actions = {
  setToken({ commit }, payload) {
    storeToLocalStorage('token', payload)
    commit('SET_TOKEN', payload)
  },
  setUser({ commit }, payload) {
    storeToLocalStorage('userName', JSON.stringify(payload))
    commit('SET_USER', payload)
  },
  setAccessLevel({ commit }, payload) {
    storeToLocalStorage('accessLevel', payload.toString())

    commit('SET_ACCESS_LEVEL', payload)
  },
  setMainPage({ commit }, payload) {
    storeToLocalStorage('mainPage', payload ?? '')
    commit('SET_MAIN_PAGE', payload)
  },
  setPages({ commit }, payload) {
    storeToLocalStorage('pages', JSON.stringify(payload))
    commit('SET_PAGES', payload)
  },
  clearToken({ commit }) {
    commit('CLEAR_TOKEN')
  },
  logout() {
    localStorage.userName = null
    localStorage.accessLevel = null
    localStorage.token = null
    localStorage.mainPage = null
  },
}

const getters = {
  exp(state) {
    if (!state.token) return null
    const { exp } = jwtDecode(state.token)
    return new Date(exp * 1000)
  },
  mainPageV2(state) {
    const page = state.pages.find(page => page.is_homepage)
    return page ? page.path : (state.mainPage || '/')
  },
  pageSet(state) {
    return new Set(state.pages.map(page => page.path))
  },
}

const authStoreModule = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
  strict: true,
}

export default authStoreModule
/**
 * @typedef {typeof Vue & {CryptoJS?: any}} VueWithCryptoJS
 */